import React from 'react';
import { FormikProps } from 'formik';
import { ButtonV2 } from '@withjoy/joykit';
import { Remove } from '@withjoy/joykit/icons';
import { Contacts, ContactInputFields } from '@apps/contactCollector/guest/ContactCollectorGuest.controller';
import { Contacts as IframeContacts, ContactInputFields as IframeContactInputFields } from '@apps/contactCollector/iframe/ContactCollectorIframe.controller';

interface RemoveMemberProps
  extends Readonly<{
    formik: FormikProps<Contacts> | FormikProps<IframeContacts>;
    remove: (index: number) => ContactInputFields | IframeContactInputFields | undefined;
    index: number;
  }> {}

export const RemoveMember: React.FC<RemoveMemberProps> = ({ remove, index }) => (
  <ButtonV2 startIcon={Remove} variant="ghost" paddingLeft={0} minWidth={0} paddingRight="0.5rem" justifyContent="flex-start" onClick={() => remove(index)} />
);
